module.exports = __webpack_public_path__ + "static/media/andrewnock.3b18dc00.png";